<template>
  <div class="form-group lm-date-time" v-if="isVisible" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <div class="d-flex" :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <flat-pickr
        v-model="dateTime"
        ref="calendar"
        :config="config"
        :class="{'is-invalid': v.$error}"
        :placeholder="placeholder"
        :id="idComputed"
        readonly="false"
        class="form-control"
        :disabled="disabled"
        :key="key"
        ></flat-pickr>
      <div class="input-group-append">
        <button class="btn btn-default input-group-text" type="button" title="Clear" @click="dateTime = ''" :disabled="disabled">
          <font-awesome-icon icon="times"/>
        </button>
      </div>
    </div>
    <p class="invalid-feedback d-block" v-if="!v.required && v.$error"> {{ $t('field_required')}} </p>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

export default {
  mixins: [lmInputMixin],
  data () {
    return {
      key: 0
    }
  },
  props: {
    config: {
      type: Object,
      default: function () {
        return {
          dateFormat: 'j-m-Y H:i',
          enableTime: true,
          locale: Spanish,
          allowInput: true
        }
      }
    }
  },
  components: {
    flatPickr
  },
  computed: {
    dateTime: {
      get () {
        return this.value
      },
      set (value) {
        if (Object.entries(this.v).length) {
          this.v.$touch()
        }
        this.$emit('input', value)
      }
    }
  },
  methods: {
    clear () {
      this.key++
    }
  }
}
</script>

<style lang="sass" scoped>
  .input-group-append
    margin-left: initial
</style>
